import React, { useState, useEffect, useCallback } from 'react';
import './ConfigModal.css';
import { useAuth } from '../contexts/AuthContext';
const apiUrl = process.env.REACT_APP_API_URL;

const crownIcon = 'https://i.imgur.com/cQ8nCek.png';

const ConfigModal = ({ isOpen, onClose, empresaId }) => {
  const [activeTab, setActiveTab] = useState('configuracoes');
  const [empresa, setEmpresa] = useState(null);
  const [funcionarios, setFuncionarios] = useState([]);
  const [administradores, setAdministradores] = useState([]);
  const [error, setError] = useState(null);
  const { token, user } = useAuth();

  const fetchEmpresa = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}empresas/${empresaId}`);
      if (!response.ok) {
        throw new Error('Empresa não encontrada.');
      }
      const data = await response.json();
      setEmpresa(data);
      setError(null);
    } catch (err) {
      setEmpresa(null);
      setError(err.message);
    }
  }, [empresaId]);

  const fetchFuncionarios = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}admins/empresas/${empresaId}/funcionarios`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar funcionários.');
      }
      const data = await response.json();
      setFuncionarios(data);
      setError(null);
    } catch (err) {
      setFuncionarios([]);
      setError(err.message);
    }
  }, [empresaId, token]);

  const fetchAdministradores = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}empresas/empresa/${empresaId}/admins`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error('Erro ao buscar administradores.');
      }
      const data = await response.json();
      setAdministradores(data);
      setError(null);
    } catch (err) {
      setAdministradores([]);
      setError(err.message);
    }
  }, [empresaId, token]);

  useEffect(() => {
    if (isOpen) {
      if (activeTab === 'configuracoes') {
        fetchEmpresa();
      } else if (activeTab === 'funcionarios') {
        fetchFuncionarios();
      } else if (activeTab === 'administradores') {
        fetchAdministradores();
      }
    }
  }, [isOpen, activeTab, fetchEmpresa, fetchFuncionarios, fetchAdministradores]);

  const handleEdit = () => {
    // Função para editar as informações da empresa
    console.log('Editar informações da empresa');
  };

  const handleDesvincular = async (adminId) => {
    try {
      const response = await fetch(`${apiUrl}empresas/empresa/${empresaId}/adm/${adminId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ id_solicitante: user.id })
      });

      const data = await response.json();

      if (response.ok) {
        setAdministradores(administradores.filter(admin => admin.id !== adminId));
        setError(null);
        alert(data.message);
      } else {
        setError(data.error);
      }
    } catch (err) {
      setError('Erro interno ao processar a solicitação.');
    }
  };

  const isPrincipal = administradores.some(admin => admin.id === user.id && admin.principal === true);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>X</button>
        <div className="modal-header">
          <button className="header-button config-modal-button" onClick={() => setActiveTab('configuracoes')}>Informações</button>
          <button className="header-button config-modal-button" onClick={() => setActiveTab('administradores')}>Administradores</button>
          <button className="header-button config-modal-button" onClick={() => setActiveTab('funcionarios')}>Colaboradores</button>
        </div>
        <div className="modal-body">
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {activeTab === 'configuracoes' && empresa && (
            <>
              <table>
                <tbody>
                  <tr>
                    <td>Nome:</td>
                    <td>{empresa.nome}</td>
                  </tr>
                  <tr>
                    <td>Setor de Atuação:</td>
                    <td>{empresa.setor_atuacao}</td>
                  </tr>
                  <tr>
                    <td>Telefone de Suporte:</td>
                    <td>{empresa.telefone_suporte}</td>
                  </tr>
                  <tr>
                    <td>Email de Suporte:</td>
                    <td>{empresa.email_suporte}</td>
                  </tr>
                </tbody>
              </table>
              <button className="edit-button" onClick={handleEdit}>Editar Informações</button>
            </>
          )}
          {activeTab === 'administradores' && (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    {isPrincipal && <th>Ações</th>}
                  </tr>
                </thead>
                <tbody>
                  {administradores.map(admin => (
                    <tr key={admin.id}>
                      <td>
                        {admin.nome}
                        {admin.principal === true && <img src={crownIcon} alt="Admin Principal" className="crown-icon" />}
                      </td>
                      <td>{admin.email}</td>
                      {isPrincipal && admin.principal !== true && admin.id !== user.id && (
                        <td>
                          <button className="desvincular-button" onClick={() => handleDesvincular(admin.id)}>Desvincular</button>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {activeTab === 'funcionarios' && (
            <div>
              <table>
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Email</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {funcionarios.map(funcionario => (
                    <tr key={funcionario.id}>
                      <td>{funcionario.nome}</td>
                      <td>{funcionario.email}</td>
                      <td>
                        <button className="desvincular-button" onClick={() => handleDesvincular(funcionario.id)}>Desvincular</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfigModal;